// Arabic copy for «البوصلة التربوية» (Milestone 0: child picker only).
import { arCount } from "@/lib/ar-count";

export const TARBAWIYA_UI = {
  title: "البوصلة التربوية",
  lead: "لأي طفل هالبوصلة؟",
  empty: "ما في أطفال مضافين لسّا.",
  addChild: "إضافة طفل",
  formTitle: "إضافة طفل",
  firstName: "الاسم الأول",
  nameHint: "الاسم بيظهر بتقارير طفلك بس.",
  birthYear: "سنة الميلاد",
  sexLabel: "ولد أو بنت؟ (اختياري)",
  male: "ولد",
  female: "بنت",
  save: "إضافة الطفل",
  saving: "جاري الإضافة…",
  back: "رجوع",
  outOfRange: "البوصلة التربوية للأطفال من عمر سنة لعمر 9 سنين.",
  error: "ما قدرنا نضيف الطفل هلّق. منجرّب كمان مرة بعد شوي؟",
} as const;

/** «سنة» / «سنتين» / «4 سنين» — no pronoun. */
export function childAgeLabel(age: number): string {
  return arCount(age, { one: "سنة", two: "سنتين", few: "سنين", many: "سنة" });
}
